<template>
  <div v-if="currentState.currentStatus != 'Assembling Friends'">
    <mdb-card class="mb-4 text-left">
      <mdb-card-header><h3>My Cards</h3></mdb-card-header>
      <mdb-card-body>
        <mdb-row>
          <word-card
            v-for="card in currentState.myCards" :key="card.id"
            :selectable="currentState.currentStatus=='Answering' && !currentState.iAnswered && !currentState.iAmModerator"
            @cardSelected="cardSelected(card)"
            :card="{class: 'primary-color-dark text-white mb-2', text: card.front}" />
        </mdb-row>

      </mdb-card-body>
    </mdb-card>
  </div>

</template>
<script>
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow,
  mdbSpinner
} from 'mdbvue';
import Avatar from "../common/Avatar";
import WordCard from "./WordCard";

export default {
  name: "group-campfire-join",
  props: {
    currentState: {
      type: Object,
      default: null
    },
    game: {
      type: Object,
      default: null
    }
  },
  components: {
    Avatar,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardFooter,
    mdbContainer,
    mdbSpinner,
    mdbRow,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    WordCard
  },
  computed: {
    settings() {
      return this.$store.state.settings
    },
  },
  data() {
    return {

    }
  },
  beforeDestroy() {

  },
  mounted() {

  },
  methods: {
    cardSelected(card) {
      this.$emit("cardSelected", card)
    }
  }
};

</script>
